import { render } from "./Lesson.vue?vue&type=template&id=4684492e&scoped=true"
import script from "./Lesson.vue?vue&type=script&lang=js"
export * from "./Lesson.vue?vue&type=script&lang=js"

import "./Lesson.vue?vue&type=style&index=0&id=4684492e&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4684492e"]])

export default __exports__